<template>
    <div class="login-container">
        <h2 class="login-title">中仑磐石系统</h2>
        <div class="login-form">
            <a-form layout="horizontal" :form="form" @submit="handleSubmit">
                <a-row>
                    <a-form-item label="用户名">
                        <a-input
                            v-decorator="[
                                        'identitykey',
                                        {
                                            rules:[{required: true, message: '用户名必填'}]
                                        }
                                    ]"
                        >
                            <a-icon slot="prefix" type="user"/>
                        </a-input>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item label="密码">
                        <a-input
                            v-decorator="[
                                        'certificate',
                                        {
                                            rules:[{required: true, message: '密码必填'}]
                                        }
                                    ]"
                            type="password"
                        >
                            <a-icon slot="prefix" type="lock"/>
                        </a-input>
                    </a-form-item>
                </a-row>
                <a-button
                    :key="this.loading.key"
                    :loading="this.loading.effects[loginType]"
                    @click="handleSubmit"
                    htmlType="submit"
                    type="primary"
                    block
                    style="margin-top:20px;"
                >登录
                </a-button>
            </a-form>
        </div>
    </div>

</template>

<script>
const storeNamespace = "home";
import jscookie from "js-cookie";

export default {
    data() {
        return {
            storeNamespace,
            loginType: `${storeNamespace}/login`,
            form: this.$form.createForm(this)
        };
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            let redirtPath = '/index';
            let c_query = this.$route.query;
            if(c_query){
                if(c_query.redirect){
                    redirtPath = c_query.redirect
                }
            }
            this.form.validateFields((err, values) => {
                if (err) return;
                values.identitytype = 1
                values.platfromcode='fp'
                this.$store
                    .dispatch({
                        type: this.loginType,
                        params: values
                    })
                    .then((res) => {
                        if (res.data.success == '1') {
                            if (res.data.data.status == '1') {
                                let UserInfo = res.data.data.user;
                                jscookie.set("fk_id", UserInfo.token,{ expires: 0.5 });
                                this.$store.commit("save", {isLogin: true})
                                UserInfo.identitykey = values.identitykey;
                                localStorage.setItem('userInfo', JSON.stringify(UserInfo));
                                localStorage.setItem('zl_logger_user_sign',UserInfo.username + '-' + UserInfo.uid);
                                //更新已授权应用列表
                                this.G.updateAuthedAppcodes(this,UserInfo.uid);
                                //清除异常监控相关缓存
                                this.G.clearMonitorCach();
                                this.$router.push({
                                    path: redirtPath
                                })
                            } else {
                                this.message.error('账户密码错误')
                            }

                        } else {
                            this.message.error('登陆失败')
                        }
                    });
            });
        },
    },
    mounted(){
    }
};
</script>

<style lang="less" scoped>

/* 背景 */
.login-container {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../../assets/login-bg.png");
}

.login-form {
    width: 400px;
    height: 300px;
    margin: 0 auto;
    background: white;
    padding: 20px 40px;
    border-radius: 12px;
}

.login-title {
    color: #fff;
    text-align: center;
    margin: 60px 0;
    font-size: 48px;
    font-family: Microsoft Yahei;
}

.ant-form-item {
    margin-bottom: 2px;
}
</style>
